import { STOP_SALES_DATE_FORMAT } from 'constants/date'
import { format } from 'date-fns'

export const formatStopSaleDate = (date?: string) =>
  date ? format(new Date(String(date)), STOP_SALES_DATE_FORMAT) : ''
